module.exports = __webpack_public_path__ + "media/images/navbar/cross-icon-9e027642871699f84f85cc18cdf9db52.svg";